import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import CardComponent from './cards';
import NoData from 'src/components/shared/noDataComponent';
import apiCalls from 'src/api/apiCalls';
import Loader from 'src/components/loader.component';
const CardsDetails = () => {

  const [physicalCardsData, setPhysicalCardsData] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const [hide, setHide] = useState(false)
  const cardDivRef = React.useRef(null);
  const { id } = useParams();
  const [viewtype, setViewtype] = useState("cardView")

  useEffect(() => {
    getphysicalCards("All");
  }, [])
  const getphysicalCards = useCallback(async () => {
    setLoader(true);
    try {
      let response = await apiCalls.getCards(id, 'All');
      if (response?.ok) {
        setHide(true);
        const groupedItems = response?.data?.reduce((acc, item) => {
          const key = item?.cardStatus;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key]?.push(item);
          return acc;
        }, {});
        const groupedItemsArray = Object.entries(groupedItems).map(([key, value]) => ({
          cardStatus: key,
          items: value,
        }));
        setPhysicalCardsData(groupedItemsArray);
      } else {
        setErrorMsg(apiCalls.isErrorDispaly(response));
        cardDivRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        setHide(true);
      }
    } catch (error) {
      setErrorMsg(error);
    } finally {
      setLoader(false);
    }
  }, [id]);

  const closeError = useCallback(() => {
    setErrorMsg(null)
  }, [])
  const gridviewHandler = (action) => {
    setViewtype(action);
  }
  return (

    <>
      <div ref={cardDivRef}></div>
      {errorMsg !== undefined && errorMsg !== null && (
        <Alert
          className='mb-6'
          type="error"
          description={errorMsg}
          onClose={closeError}
          showIcon
          closable
        />
      )}
      <div className='loader-center'>
        {loader && <Loader />}
      </div>
      <div>
        {hide && <div>
          {physicalCardsData !== null && physicalCardsData?.length === 0 && !loader && (
            <NoData />
          )}
          {physicalCardsData?.length > 0 && physicalCardsData.map(item => (
            <div key={item?.id}>
              <div className='text-end flex justify-end items-center gap-3 mb-3'>
                <Tooltip title="Card View"><div className={`cursor-pointer ${viewtype === "cardView" ? "active" : "notactive"}`} onClick={() => gridviewHandler("cardView")}><span className='icon lg cardview-icon edit-icon cursor-pointer'></span></div></Tooltip>
                <Tooltip title="List View"><div className={`cursor-pointer ${viewtype !== "listView" ? "active" : "notactive "}`} onClick={() => gridviewHandler("listView")}><span className='icon lg listview-icon cursor-pointer'></span></div></Tooltip>
              </div>
              <div className={`rounded-5 border border-StrokeColor bg-transparentBlackBg  ${viewtype === 'cardView' && 'grid grid-cols-1 gap-4'}`}>
                <CardComponent cardData={item?.items} cardType={item.cardType} viewtype={viewtype} />
              </div>
              <Outlet />
            </div>
          ))}
        </div>}
      </div>
    </>
  )
}

const connectStateToProps = ({ userConfig, oidc }) => {
  return { userConfig: userConfig?.userProfileInfo, user: oidc?.user }
}

export default connect(connectStateToProps)(CardsDetails)